import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import device from 'current-device';
import { SettingsService } from 'src/app/services/account/settings.service';
import { LanguageService } from 'src/app/services/account/language.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { ModalOptionPanelComponent } from '../modal-option-panel/modal-option-panel.component';


@Component({
  standalone: true,
  selector: 'app-gps-error-dialog',
  templateUrl: './gps-error-dialog.component.html',
  imports: [ModalOptionPanelComponent],
  styleUrls: ['./gps-error-dialog.component.scss']
})
export class GpsErrorDialogComponent implements OnInit {

  private androidChromeText: string[] = [];
  private androidFirefoxText: string[] = [];
  private iphoneSafariText: string[] = [];
  private iphoneSafari12Text: string[] = [];
  private iphoneChromeText: string[] = [];
  private dekstopChromeText: string[] = [];
  private desktopFirefoxText: string[] = [];
  private desktopEdgeText: string[] = [];
  private desktopSafariText: string[] = [];
  private desktopMacChromeText: string[] = [];

  /**
   * showing error dialog, when the user not allowed gps location
   */
  constructor(
    public dialogRef: MatDialogRef<GpsErrorDialogComponent>,
    public settingsService: SettingsService,
    public languageService: LanguageService,
    private readonly utilsService:UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  public fbAndroid: boolean = navigator.userAgent.includes('FB_IAB');
  public fbIos: boolean = navigator.userAgent.includes('FBIOS');
  public informationText: string[] = [];
  private browser: string = "";

  ngOnInit(): void {
    this.androidChromeText = [
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command1,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command2,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command3,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command4
    ];
  
    this.androidFirefoxText = [
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command1,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command2,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command5,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command6,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command4
    ];
  
    this.iphoneSafariText = [
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command7,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command8,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command9,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command10,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command11,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command12,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command13,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command4
    ];
  
    this.iphoneSafari12Text = [
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command7,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command8,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command9,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command10,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command7,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command14,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command15,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command16,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command4
    ];
  
    this.iphoneChromeText = [
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command7,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command8,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command9,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command17,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command4
    ];
  
    this.dekstopChromeText = [
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command1,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command18,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command19,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command4
    ];
  
    this.desktopFirefoxText = [
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command1,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command20,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command6,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command4
    ];
  
    this.desktopEdgeText = [
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command1,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command21,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command4
    ];
  
    this.desktopSafariText = [
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command22,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command23,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command24,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command26,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command4
    ];
  
    this.desktopMacChromeText = [
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command1,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command25,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command26,
      this.languageService.languageJSON.GPSErrorDialog_Definition_Command4
    ];

    // browser detection
    this.detectBrowser();
    this.informationText = this.getPlatformInformationText();
  }

  private getPlatformInformationText(): string[] {
    if (device.desktop()) {
      return this.getDesktopInformationText();
    }
    if (device.android()) {
      return this.browser == "Firefox" ? this.androidFirefoxText : this.androidChromeText;
    }
    if (device.ios()) {
      return this.getIosInformationText();
    }
    return this.androidChromeText;
  }

  private getDesktopInformationText(): string[] {
    if ((device.os as any) == "macos") {
      return this.browser == "Chrome" ? this.desktopMacChromeText : this.desktopSafariText;
    }
    if (this.browser == "Firefox") {
      return this.desktopFirefoxText;
    }
    if (this.browser == "Edge") {
      return this.desktopEdgeText;
    }
    return this.dekstopChromeText;
  }

  // iOS versions (12 and older) whose Safari gets its own steps
  private readonly legacyIosVersions: string[] = ['12', '11', '10', '9', '8', '7'];

  private getIosInformationText(): string[] {
    //chrome
    if (/CriOS/.exec(navigator.userAgent)) {
      return this.iphoneChromeText;
    }
    //safari (iOS 12 and older)
    if (this.legacyIosVersions.some(version => navigator.userAgent.includes('iPhone OS ' + version))) {
      return this.iphoneSafari12Text;
    }
    //safari
    return this.iphoneSafariText;
  }

  public accept(): void {
    this.dialogRef.close();
  }

  // browser detection data
  private readonly databrowser: { name: string, value: string, version: string }[] = [
    { name: 'Chrome', value: 'Chrome', version: 'Chrome' },
    { name: 'Firefox', value: 'Firefox', version: 'Firefox' },
    { name: 'Safari', value: 'Safari', version: 'Version' },
    { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
    { name: 'Edge', value: 'Edge', version: 'Edge' },
    { name: 'Opera', value: 'Opera', version: 'Opera' },
    { name: 'BlackBerry', value: 'CLDC', version: 'CLDC' },
    { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' }
  ];

  // regex compare navigator data
  private matchItem(string: string, data: { name: string, value: string, version: string }[]): { name: string, version: number } {
    const item = data.find(entry => new RegExp(entry.value, 'i').test(string));
    if (!item) {
      return { name: 'unknown', version: 0 };
    }
    return {
      name: item.name,
      version: this.parseVersion(string, item.version)
    };
  }

  // "<marker>/12_1.3" -> 12.13: the first part, a dot, then the remaining parts run together
  private parseVersion(string: string, marker: string): number {
    const matches = new RegExp(marker + String.raw`[- /:;]([\d._]+)`, 'i').exec(string);
    if (!matches?.[1]) {
      return 0;
    }
    const [major, ...rest] = matches[1].split(/[._]+/);
    return Number.parseFloat(major + '.' + rest.join(''));
  }

  private detectBrowser(): void {
    // Only the user agent can name a browser here: the deprecated platform/appVersion/vendor
    // strings that used to be joined in never contain any of the databrowser markers.
    const agent = navigator.userAgent,
      browser = this.matchItem(agent, this.databrowser);
    const edge = this.detectEdge();
    this.browser = edge ? "Edge" : browser.name;
  }

  // edge detection
  private detectEdge(): number {
    const ua = globalThis.navigator.userAgent;

    // Test values; Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

    // Edge 12 (Spartan)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

    // Edge 13
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return Number.parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      const rv = ua.indexOf('rv:');
      return Number.parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    const edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return Number.parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return 0;
  }

  public openUrl(url): void {
    this.utilsService.openUrlOnNewTab(device, url);
  }
}
